import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 items-start" }
const _hoisted_2 = { class: "mt-1 sm:col-span-2 sm:mt-0" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-2"
}
const _hoisted_4 = ["disabled", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "mt-1 text-sm text-red-600"
}

import { XMarkIcon } from '@heroicons/vue/20/solid'
import { ref } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'


export default {
  __name: 'DiscountCodeInput',
  props: {
  appliedCodes: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false }
},
  emits: ['apply', 'remove'],
  setup(__props, { expose: __expose, emit: __emit }) {


const emit = __emit

const value = ref('')
const errorMessage = ref('')

const submit = () => {
  const code = value.value.trim()
  if (!code) return
  errorMessage.value = ''
  emit('apply', code)
}

const showError = message => {
  errorMessage.value = message || 'This code is invalid'
}

const clear = () => {
  value.value = ''
  errorMessage.value = ''
}

__expose({ showError, clear })

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Discount code", -1)),
    _createElementVNode("dd", _hoisted_2, [
      (__props.appliedCodes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.appliedCodes, (applied) => {
              return (_openBlock(), _createElementBlock("span", {
                key: applied.id,
                class: "inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-sm text-gray-800"
              }, [
                _createTextVNode(_toDisplayString(applied.attributes.code) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "ml-2 text-gray-400 hover:text-gray-700",
                  disabled: __props.disabled,
                  onClick: $event => (_ctx.$emit('remove', applied.id))
                }, [
                  _createVNode(_unref(XMarkIcon), { class: "h-4 w-4" })
                ], 8, _hoisted_4)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        class: "flex items-center gap-2 max-w-sm",
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((value).value = $event)),
          type: "text",
          placeholder: "Discount code",
          class: _normalizeClass(["block w-full rounded-md border border-gray-300 shadow-sm sm:text-sm", 
            errorMessage.value
              ? 'border-red-500 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500'
              : 'focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500'
          ]),
          onInput: _cache[1] || (_cache[1] = $event => (errorMessage.value = ''))
        }, null, 34), [
          [_vModelText, value.value]
        ]),
        _createVNode(NeueButton, {
          type: "secondary",
          disabled: __props.disabled || !value.value.trim(),
          onClick: submit
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Apply", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"])
      ], 32),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}